import { ResponseRegisterSuccess } from '@/types';
import {
  CustomizedInitialEvent,
  enviarEvento,
  enviarEventoFinRegistracion,
} from '@/utils/gtm';

export const tracking = () => {
  /**
   * Sólo al final de una registración exitosa.
   * Envia un evento a Google Tag Manager.
   * @param data
   */
  const trackFinRegistracion = (data: ResponseRegisterSuccess) => {
    enviarEventoFinRegistracion(data);
  };

  /**
   * Luego de cada autenticación exitosa (callback)
   * @param data
   */
  const trackRegistration = (data: CustomizedInitialEvent) => {
    enviarEvento(data);
  };

  return {
    trackFinRegistracion,
    trackRegistration,
  };
};
